/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.fillSubCase', {
      url: '/:caseId/subCase/:id/fill?readOnly',
      template: '<fill-sub-case sub-case="$resolve.subCase"></fill-sub-case>',
      resolve: {
        /* @ngInject */
        subCase: ($http, $stateParams, $state) => $http
          .get(`/subCase/${$stateParams.id}/template`)
          .then(({ data }) => data)
          .catch(() => $state.go('four-o-three')),
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/fillSubCase/fillSubCase.routes.js